var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{staticClass:"one-error-500"},[_vm._v("\n  "+_vm._s(_vm.$t('error_page.error_occurred'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }